export default "__VITE_ASSET__Dz0kbvOY__"